import {
  IconButton,
  Tab,
  Tabs,
  TextField,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import React, { useState, useReducer, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './Template-Create.scss';
import { DragIndicator, Edit, RemoveCircleRounded } from '@material-ui/icons';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { notificationManager } from '../../../../../../../utils/NotificationUtils';
import { formDataValidate } from '../../../../../../../utils/formUtils';
import CustomSelect from '../../../../../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import LinearProgressBar from '../../../../../../../shared/progress-bar/Progress';
import VendorCard from '../../../../../../../components/vendor-card/VendorCard';
import {
  fetchGRETemplates,
  greGlobalDefaultTabSelector,
  vendorsSelector,
} from '../../../../../configurationSlice';
import {
  CURTAIN,
  LIGHT,
  SCENE,
  THERMO,
  DOOR_LOCK,
} from '../../../../../../../constants/VendorConst';
import {
  curtainType,
  lightIcons,
  lightType,
} from '../../../../../../../constants/ConfigurationsConst';
import {
  createNewTempalte,
  updateExisitingTempalte,
} from '../../../../../../../utils/IntegrationsAPIUtils';
import { isEmpty } from 'lodash';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../../../utils/loaderSlice';

const GuestRoomExperienceTemplateCreate = (props) => {
  const { toggleDrawer, template, hotelId, onDrawerToggle, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = useState(0);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [loading, setLoading] = useState(false);
  const data = useSelector(greGlobalDefaultTabSelector);
  const [nameLanguages, setNameLanguages] = useState([]);
  const [nameLanguageDoorLock, setNameLanguageDoorLock] = useState([]);
  const allVendors = useSelector(vendorsSelector);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: {
      value: '',
      fieldName: 'Template Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    doorCamera: {
      value: 'active',
      fieldName: 'Door Camera',
      errors: {},
      validations: [],
      tab: 1,
    },
    areas: {
      value: [],
      fieldName: 'Room Areas',
      errors: {},
      validations: [],
      tab: 0,
    },
    lights: {
      value: [],
      fieldName: 'Lights',
      errors: {},
      validations: [],
      tab: 1,
    },
    lightsVendor: {
      value: '',
      fieldName: 'Vendor',
      errors: {},
      validations: [],
      tab: 1,
    },
    scenes: {
      value: [],
      fieldName: 'Scenes',
      errors: {},
      validations: [],
      tab: 2,
    },
    scenesVendor: {
      value: '',
      fieldName: 'Vendor',
      errors: {},
      validations: [],
      tab: 2,
    },
    thermostats: {
      value: [],
      fieldName: 'Thermostats',
      errors: {},
      validations: [],
      tab: 3,
    },
    thermostatVendor: {
      value: '',
      fieldName: 'Vendor',
      errors: {},
      validations: [],
      tab: 3,
    },
    curtains: {
      value: [],
      fieldName: 'Curtains',
      errors: {},
      validations: [],
      tab: 4,
    },
    curtainsVendor: {
      value: '',
      fieldName: 'Vendor',
      errors: {},
      validations: [],
      tab: 4,
    },
    doorLockVendor: {
      value: '',
      fieldName: 'Vendor',
      errors: {},
      validations: [],
      tab: 5,
    },
    doorLockName: {
      value: '',
      fieldName: 'Door Lock Name',
      errors: {},
      validations: [],
      tab: 5,
    },
    doorLockId: {
      value: '',
      fieldName: 'Door Lock Id',
      errors: {},
      validations: [],
      tab: 5,
    },
  });

  const [areaFormData, setAreaFormData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      name: {
        value: '',
        fieldName: 'Room Area Name',
        errors: {},
        validations: ['required'],
        tab: -1,
      },
      id: {
        value: '',
        fieldName: 'Room Area Id',
        errors: {},
        validations: ['required'],
        tab: -1,
      },
    },
  );

  const [lightFormData, setLightFormData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      roomArea: {
        value: '',
        fieldName: 'Select Room Area',
        errors: {},
        validations: ['required'],
        tab: -1,
      },
      name: {
        value: '',
        fieldName: 'Light Name',
        errors: {},
        validations: ['required'],
        tab: -1,
      },
      type: {
        value: '',
        fieldName: 'Light Type',
        errors: {},
        validations: ['required'],
        tab: -1,
      },
      dimmerLevel: {
        value: '',
        fieldName: 'Select Dimmer Levels',
        errors: {},
        validations: [],
        tab: -1,
      },
      icon: {
        value: '',
        fieldName: 'Light Icon',
        errors: {},
        validations: ['required'],
        tab: -1,
      },
      id: {
        value: '',
        fieldName: 'Light Id',
        errors: {},
        validations: ['required'],
        tab: -1,
      },
    },
  );

  const [thermostatFormData, setThermostatFormData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      roomArea: {
        value: '',
        fieldName: 'Select Room Area',
        errors: {},
        validations: ['required'],
        tab: -1,
      },
      name: {
        value: '',
        fieldName: 'Thermostat Name',
        errors: {},
        validations: ['required'],
        tab: -1,
      },
      id: {
        value: '',
        fieldName: 'Thermostat Id',
        errors: {},
        validations: ['required'],
        tab: -1,
      },
    },
  );

  const [curtainFormData, setCurtaintFormData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      roomArea: {
        value: '',
        fieldName: 'Select Room Area',
        errors: {},
        validations: ['required'],
        tab: -1,
      },
      name: {
        value: '',
        fieldName: 'Curtain Name',
        errors: {},
        validations: ['required'],
        tab: -1,
      },
      type: {
        value: '',
        fieldName: 'Curtain Type',
        errors: {},
        validations: ['required'],
        tab: -1,
      },
      id: {
        value: '',
        fieldName: 'Curtain Id',
        errors: {},
        validations: ['required'],
        tab: -1,
      },
    },
  );

  const [sceneFormData, setSceneFormData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      roomArea: {
        value: '',
        fieldName: 'Select Room Area',
        errors: {},
        validations: ['required'],
        tab: -1,
      },
      name: {
        value: '',
        fieldName: 'Scene Name',
        errors: {},
        validations: ['required'],
        tab: -1,
      },
      type: {
        value: '',
        fieldName: 'Light Type',
        errors: {},
        validations: ['required'],
        tab: -1,
      },
      dimmerLevel: {
        value: '',
        fieldName: 'Select Dimmer Levels',
        errors: {},
        validations: [],
        tab: -1,
      },
      id: {
        value: '',
        fieldName: 'Scene Id',
        errors: {},
        validations: ['required'],
        tab: -1,
      },
    },
  );

  const [vendorAttribute, setVendorAttribute] = useState({
    lights: {
      default: [],
      custom: [],
    },
    scenes: {
      default: [],
      custom: [],
    },
    thermostats: {
      default: [],
      custom: [],
    },
    curtains: {
      default: [],
      custom: [],
    },
    doorLock: {
      default: [],
      custom: [],
    },
  });

  useEffect(() => {
    if (data) {
      setNameLanguages(
        data?.languages?.map((language) => {
          return {
            langageValue: '',
            languageCode: language.languageCode,
            languageName: language.languageName,
            value: '',
            fieldName: 'name (' + language.languageName + ')',
            errors: {},
            validations: ['required'],
          };
        }),
      );
      setNameLanguageDoorLock(
        data?.languages?.map((language) => {
          let langValue = '';
          if (template) {
            langValue = template?.doorLock?.nameAliases?.find(
              (doorLockLangAlias) => doorLockLangAlias.languageId === language.languageCode,
            )?.alias;
          }
          return {
            languageCode: language.languageCode,
            languageName: language.languageName,
            value: template ? langValue ?? '' : '',
            fieldName: 'name (' + language.languageName + ')',
            errors: {},
            validations: [],
          };
        }),
      );
    }
  }, [data]);

  const onVendorSelect = (e, field) => {
    setFormData({ [field]: e });
  };

  const convertEnumToReadable = (arr, value) => {
    return arr?.find((item) => item.id === value)?.name;
  };

  const convertReadableToEnum = (arr, value) => {
    return arr?.find((item) => item.name === value)?.id;
  };

  const refactorLanguageList = (nameList) => {
    if (data) {
      return nameList
        ?.map((lang) => {
          const obj = data?.languages?.find((item) => item.languageCode === lang.languageId);
          if (obj) {
            return {
              langageValue: lang.alias,
              languageCode: lang.languageId,
              languageName: obj.languageName,
              value: lang.alias,
              fieldName: `Name (${obj.languageName})`,
              errors: { required: null },
              validations: ['required'],
            };
          } else return null;
        })
        .filter((item) => item !== null);
    }
  };

  useEffect(() => {
    if (template) {
      const templateCopy = { ...template };
      const formDataCopy = { ...formData };
      formDataCopy.name.value = templateCopy.name;
      formDataCopy.doorCamera.value = templateCopy.doorCameraEnabled ? 'active' : 'inactive';
      formDataCopy.lightsVendor.value = templateCopy.lightsVendor.id;
      formDataCopy.scenesVendor.value = templateCopy.scenesVendor.id;
      formDataCopy.thermostatVendor.value = templateCopy.thermostatVendor.id;
      formDataCopy.curtainsVendor.value = templateCopy.curtainsVendor.id;
      formDataCopy.doorLockVendor.value = templateCopy.doorLockVendor.id;
      formData.doorLockName.value = templateCopy.doorLock.name;
      formData.doorLockId.value = templateCopy.doorLock.id;
      formDataCopy.areas.value =
        templateCopy?.areas?.map((item, index) => {
          return {
            index: index + 1,
            id: item.id,
            name: item.name,
            languageNames: refactorLanguageList(item.nameAliases),
          };
        }) ?? [];
      formDataCopy.lights.value =
        mergeTwoList(
          templateCopy?.areas?.map((area, index) => {
            return area.lights.map((item, index) => {
              return {
                index: index + 1,
                name: item?.name,
                icon: item?.icon,
                dimmerLevel: item?.dimmerLevel,
                type: convertEnumToReadable(lightType, item?.type),
                roomArea: area?.id,
                id: item?.id,
                languageNames: refactorLanguageList(item.nameAliases),
              };
            });
          }),
        ) ?? [];
      formDataCopy.scenes.value =
        mergeTwoList(
          templateCopy?.areas?.map((area, index) => {
            return area.scenes.map((item, index) => {
              return {
                index: index + 1,
                name: item?.name,
                icon: item?.icon,
                dimmerLevel: item?.dimmerLevel,
                type: convertEnumToReadable(lightType, item?.type),
                roomArea: area?.id,
                id: item?.id,
                languageNames: refactorLanguageList(item.nameAliases),
              };
            });
          }),
        ) ?? [];
      formDataCopy.thermostats.value =
        mergeTwoList(
          templateCopy?.areas?.map((area, index) => {
            return area.thermostats.map((item, index) => {
              return {
                index: index + 1,
                name: item?.name,
                roomArea: area?.id,
                id: item?.id,
                languageNames: refactorLanguageList(item.nameAliases),
              };
            });
          }),
        ) ?? [];
      formDataCopy.curtains.value =
        mergeTwoList(
          templateCopy?.areas?.map((area, index) => {
            return area.curtains.map((item, index) => {
              return {
                index: index + 1,
                name: item?.name,
                type: convertEnumToReadable(curtainType, item?.type),
                roomArea: area?.id,
                id: item?.id,
                languageNames: refactorLanguageList(item.nameAliases),
              };
            });
          }),
        ) ?? [];
      updateVendorAttributes(templateCopy);
    }
  }, [template]);

  useEffect(() => {
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, false);
    setIsTabInValid(!isValid);
  }, [formData, tabValue]);

  const mergeTwoList = (arr) => {
    const newArr = [];
    arr?.forEach((item) => {
      item?.forEach((i) => {
        newArr.push(i);
      });
    });
    return newArr;
  };

  const updateVendorAttributes = (templateCopy) => {
    const vendorAttrCopy = { ...vendorAttribute };
    vendorAttrCopy.lights.custom =
      templateCopy.lightsVendor?.controlSpecificAttributes?.map((item) => {
        return {
          key: item.key,
          value: item.value ?? '',
        };
      }) ?? [];
    vendorAttrCopy.lights.default =
      templateCopy.lightsVendor?.attributes?.map((item) => {
        return {
          key: item.key,
          value: item.value ?? '',
        };
      }) ?? [];
    vendorAttrCopy.scenes.custom =
      templateCopy.scenesVendor?.controlSpecificAttributes?.map((item) => {
        return {
          key: item.key,
          value: item.value ?? '',
        };
      }) ?? [];
    vendorAttrCopy.scenes.default =
      templateCopy.scenesVendor?.attributes?.map((item) => {
        return {
          key: item.key,
          value: item.value ?? '',
        };
      }) ?? [];
    vendorAttrCopy.thermostats.custom =
      templateCopy.thermostatVendor?.controlSpecificAttributes?.map((item) => {
        return {
          key: item.key,
          value: item.value ?? '',
        };
      }) ?? [];
    vendorAttrCopy.thermostats.default =
      templateCopy.thermostatVendor?.attributes?.map((item) => {
        return {
          key: item.key,
          value: item.value ?? '',
        };
      }) ?? [];
    vendorAttrCopy.curtains.custom =
      templateCopy.curtainsVendor?.controlSpecificAttributes?.map((item) => {
        return {
          key: item.key,
          value: item.value ?? '',
        };
      }) ?? [];
    vendorAttrCopy.curtains.default =
      templateCopy.curtainsVendor?.attributes?.map((item) => {
        return {
          key: item.key,
          value: item.value ?? '',
        };
      }) ?? [];
    vendorAttrCopy.doorLock.custom =
      templateCopy.doorLockVendor?.controlSpecificAttributes?.map((item) => {
        return {
          key: item.key,
          value: item.value ?? '',
        };
      }) ?? [];
    vendorAttrCopy.doorLock.default =
      templateCopy.doorLockVendor?.attributes?.map((item) => {
        return {
          key: item.key,
          value: item.value ?? '',
        };
      }) ?? [];
  };

  const validate = (form, tabValue, updateForm, nameAliasesValidate, doorLockAliasesValidate) => {
    const errObj = [];
    const updatedFields = {};
    let formToValidate = { ...form };
    if (tabValue !== -1) {
      formToValidate = Object.fromEntries(
        Object.entries(formToValidate).filter(([key, field]) => {
          return field.tab === tabValue;
        }),
      );
    }
    let isValid = formDataValidate(formToValidate, updatedFields);
    updateForm(updatedFields);

    if (tabValue === null) {
      if (formData.lightsVendor.value !== '' && isEmpty(formData.lights?.value)) {
        isValid = false;
        errObj.push('light');
      }

      if (formData.curtainsVendor.value !== '' && isEmpty(formData.curtains?.value)) {
        isValid = false;
        errObj.push('curtain');
      }

      if (formData.scenesVendor.value !== '' && isEmpty(formData.scenes?.value)) {
        isValid = false;
        errObj.push('scene');
      }

      if (formData.thermostatVendor.value !== '' && isEmpty(formData.thermostats?.value)) {
        isValid = false;
        errObj.push('thermostat');
      }

      if (errObj.length > 0) {
        notificationManager('danger', `Please add atleast one ${errObj.join(', ')}`);
      }
    }

    // Validate Name Aliases Fields
    if (nameAliasesValidate && !validateNameAliases()) {
      isValid = false;
    }
    if (doorLockAliasesValidate && !validateDoorLockAliases()) {
      isValid = false;
    }
    return isValid;
  };

  const validateNameAliases = () => {
    let isValid = true;
    if (nameLanguages) {
      const nameLanguagesCopy = [...nameLanguages];
      const updatedLanguages = nameLanguagesCopy.map((item) => {
        const currField = { ...item };
        if (!currField?.langageValue || currField?.langageValue === 0) {
          currField.errors['required'] = 'Name alias is required';
          isValid = false;
        }
        return currField;
      });
      setNameLanguages(updatedLanguages);
    }

    return isValid;
  };

  const validateDoorLockAliases = () => {
    let isValid = true;
    const nameLanguagesCopy = [...nameLanguageDoorLock];
    const updatedLanguages = nameLanguagesCopy.map((item) => {
      const currField = { ...item };
      if (!currField?.value || currField?.value === 0) {
        currField.errors['required'] = 'Name alias is required';
        isValid = false;
      }
      return currField;
    });
    setNameLanguageDoorLock(updatedLanguages);
    return isValid;
  };

  const onNextClick = () => {
    if (validate(formData, tabValue, setFormData, false, false)) {
      setTabValue(tabValue + 1);
    }
    clearLanguageInputs();
  };

  const onCancel = (e) => {
    toggleDrawer(false);
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
    } else if (
      (tabValue === 0 && formData.areas.value.length === 0) ||
      (tabValue === 1 &&
        formData.lightsVendor.value !== '' &&
        formData.lights.value.length === 0) ||
      (tabValue === 2 &&
        formData.scenesVendor.value !== '' &&
        formData.scenes.value.length === 0) ||
      (tabValue === 3 &&
        formData.thermostatVendor.value !== '' &&
        formData.thermostats.value.length === 0) ||
      (tabValue === 4 &&
        formData.curtainsVendor.value !== '' &&
        formData.curtains.value.length === 0)
    )
      return;
    else if (validate(formData, tabValue, setFormData, false, false)) {
      setTabValue(newValue);
    }
    clearLanguageInputs();
  };

  const onItemAdd = (currFromData, listField, updateCurrForm) => {
    if (validate(currFromData, -1, updateCurrForm, true, false)) {
      const mainFormField = { ...formData[listField] };
      const currList = [...mainFormField.value];
      const addingObj = { index: currList.length + 1 };
      const resetObj = {};

      Object.keys(currFromData).forEach((field) => {
        addingObj[field] = currFromData[field].value;
        addingObj['languageNames'] = nameLanguages;
        resetObj[field] = currFromData[field];
        resetObj[field].value = '';
        resetObj[field].errors = {};
      });
      clearLanguageInputs();

      currList.push(addingObj);
      mainFormField.value = currList;
      setFormData({ [listField]: mainFormField });
      updateCurrForm(resetObj);
    }
  };

  const clearLanguageInputs = () => {
    if (nameLanguages) {
      setNameLanguages(
        nameLanguages.map((item) => {
          let val = { ...item };
          val.value = '';
          val.langageValue = '';
          val.errors = {};
          return val;
        }),
      );
    }
  };

  const onItemDelete = (index, listField) => {
    const currField = { ...formData[listField] };

    const list = currField.value;
    list.splice(index, 1);
    currField.value = list;
    setFormData({ [listField]: currField });
  };

  const updateLangList = (selectedArr) => {
    if (nameLanguages) {
      const nameLanguagesCopy = nameLanguages.map((item) => {
        const itemCopy = { ...item };
        itemCopy.langageValue = selectedArr.find(
          (lang) => lang.languageCode === item.languageCode,
        )?.langageValue;
        return itemCopy;
      });
      setNameLanguages(nameLanguagesCopy);
    }
  };

  const onItemEdit = (index, listField, form) => {
    const currValues = { ...formData[listField] }?.value ?? [];

    const selectedItem = currValues[index];
    switch (form) {
      case 'AREA_FORM':
        const areaFormCopy = { ...areaFormData };
        areaFormCopy.name.value = selectedItem?.name;
        areaFormCopy.id.value = selectedItem?.id;
        updateLangList(selectedItem?.languageNames);
        setAreaFormData(areaFormCopy);
        break;
      case 'LIGHT_FORM':
        const lightFormDataCopy = { ...lightFormData };
        lightFormDataCopy.roomArea.value = selectedItem?.roomArea;
        lightFormDataCopy.name.value = selectedItem?.name;
        lightFormDataCopy.type.value =
          convertReadableToEnum(lightType, selectedItem?.type) ?? selectedItem?.type;
        lightFormDataCopy.dimmerLevel.value = selectedItem?.dimmerLevel;
        lightFormDataCopy.icon.value = selectedItem?.icon;
        lightFormDataCopy.id.value = selectedItem?.id;
        updateLangList(selectedItem?.languageNames);
        setAreaFormData(lightFormDataCopy);
        break;
      case 'SCENE_FORM':
        const sceneFormDataCopy = { ...sceneFormData };
        sceneFormDataCopy.roomArea.value = selectedItem?.roomArea;
        sceneFormDataCopy.name.value = selectedItem?.name;
        sceneFormDataCopy.type.value =
          convertReadableToEnum(lightType, selectedItem?.type) ?? selectedItem?.type;
        sceneFormDataCopy.dimmerLevel.value = selectedItem?.dimmerLevel;
        sceneFormDataCopy.id.value = selectedItem?.id;
        updateLangList(selectedItem?.languageNames);
        setSceneFormData(sceneFormDataCopy);
        break;
      case 'THERMO_FORM':
        const thermostatFormDataCopy = { ...thermostatFormData };
        thermostatFormDataCopy.roomArea.value = selectedItem?.roomArea;
        thermostatFormDataCopy.name.value = selectedItem?.name;
        thermostatFormDataCopy.id.value = selectedItem?.id;
        updateLangList(selectedItem?.languageNames);
        setThermostatFormData(thermostatFormDataCopy);
        break;
      case 'CURTAIN_FORM':
        const curtainFormDataCopy = { ...curtainFormData };
        curtainFormDataCopy.roomArea.value = selectedItem?.roomArea;
        curtainFormDataCopy.name.value = selectedItem?.name;
        curtainFormDataCopy.type.value =
          convertReadableToEnum(curtainType, selectedItem?.type) ?? selectedItem?.type;
        curtainFormDataCopy.id.value = selectedItem?.id;
        updateLangList(selectedItem?.languageNames);
        setCurtaintFormData(curtainFormDataCopy);
        break;
      default:
        break;
    }
    onItemDelete(index, listField);
  };

  // ------ Start DragNDrop Component Helper Functions ------ //
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const grid = 8;
  const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    padding: 6,
    margin: `0 0 ${grid}px 0`,
    color: '#828282',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: '#FBFBFB',
    border: isDragging ? '2px solid #03E67C' : '2px solid #FBFBFB',
    ...draggableStyle,
  });

  const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? '#CFF8E0' : '#FFF',
    padding: grid,
    width: '100%',
  });

  const onDragEnd = (result, listField) => {
    if (!result.destination) {
      return;
    }
    const items = reorder(formData[listField].value, result.source.index, result.destination.index);
    const mainFormField = { ...formData[listField] };
    mainFormField.value = items;
    setFormData({ [listField]: mainFormField });
  };
  // ------ End DragNDrop Component Helper Functions ------ //

  const buildVendorObj = (vendorId, type) => {
    if (vendorId && vendorId === '') {
      return '';
    }
    switch (type) {
      case LIGHT:
        const currLightVendor = allVendors?.lights.find((vendor) => vendor.id === vendorId);
        return {
          id: vendorId,
          name: currLightVendor?.name ?? '',
          attributes: vendorAttribute.lights.default ?? [],
          controlSpecificAttributes: vendorAttribute.lights.custom ?? [],
        };
      case SCENE:
        const currSceneVendor = allVendors?.scenes.find((vendor) => vendor.id === vendorId);
        return {
          id: vendorId,
          name: currSceneVendor?.name ?? '',
          attributes: vendorAttribute.scenes.default ?? [],
          controlSpecificAttributes: vendorAttribute.scenes.custom ?? [],
        };
      case THERMO:
        const currThermoVendor = allVendors?.thermostats.find((vendor) => vendor.id === vendorId);
        return {
          id: vendorId,
          name: currThermoVendor?.name ?? '',
          attributes: vendorAttribute.thermostats.default ?? [],
          controlSpecificAttributes: vendorAttribute.thermostats.custom ?? [],
        };
      case CURTAIN:
        const currCurtainVendor = allVendors?.curtains.find((vendor) => vendor.id === vendorId);
        return {
          id: vendorId,
          name: currCurtainVendor?.name ?? '',
          attributes: vendorAttribute.curtains.default ?? [],
          controlSpecificAttributes: vendorAttribute.curtains.custom ?? [],
        };
      case DOOR_LOCK:
        const currDoorLockVendor = allVendors?.doorLock.find((vendor) => vendor.id === vendorId);
        return {
          id: vendorId,
          name: currDoorLockVendor?.name ?? '',
          attributes: vendorAttribute.doorLock.default ?? [],
          controlSpecificAttributes: vendorAttribute.doorLock.custom ?? [],
        };
      default:
        return '';
    }
  };

  const buildLightObject = (obj) => {
    return (
      obj &&
      obj.map((item) => {
        return {
          name: item?.name,
          type: lightType.find((type) => type.name === item.type)?.id ?? item.type,
          dimmerLevel: parseInt(item?.dimmerLevel),
          icon: item?.icon,
          id: item?.id,
          nameAliases: item?.languageNames.map((lang) => {
            return {
              languageId: lang.languageCode,
              alias: lang.value,
            };
          }),
        };
      })
    );
  };

  const buildSceneObject = (obj) => {
    return (
      obj &&
      obj.map((item) => {
        return {
          name: item?.name,
          type: lightType.find((type) => type.name === item.type)?.id ?? item.type,
          dimmerLevel: parseInt(item?.dimmerLevel),
          id: item?.id,
          nameAliases: item?.languageNames.map((lang) => {
            return {
              languageId: lang.languageCode,
              alias: lang.value,
            };
          }),
        };
      })
    );
  };

  const buildCurtainObject = (obj) => {
    return (
      obj &&
      obj.map((item) => {
        return {
          name: item?.name,
          id: item?.id,
          type: curtainType.find((cur) => cur.name === item.type)?.id ?? item.type,
          nameAliases: item?.languageNames.map((lang) => {
            return {
              languageId: lang.languageCode,
              alias: lang.value,
            };
          }),
        };
      })
    );
  };

  const buildThermoObject = (obj) => {
    return (
      obj &&
      obj.map((item) => {
        return {
          name: item?.name,
          id: item?.id,
          nameAliases: item?.languageNames.map((lang) => {
            return {
              languageId: lang.languageCode,
              alias: lang.value,
            };
          }),
        };
      })
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate(formData, tabValue, setFormData, false, false)) {
      setLoading(true);
      const payload = {
        name: formData.name.value,
        hotelId: hotelId,
        doorCameraEnabled: formData.doorCamera.value === 'active',
        lightsVendor: buildVendorObj(formData.lightsVendor.value, LIGHT),
        scenesVendor: buildVendorObj(formData.scenesVendor.value, SCENE),
        thermostatVendor: buildVendorObj(formData.thermostatVendor.value, THERMO),
        curtainsVendor: buildVendorObj(formData.curtainsVendor.value, CURTAIN),
        doorLockVendor: buildVendorObj(formData.doorLockVendor.value, DOOR_LOCK),
        doorLock: {
          name: formData.doorLockName.value,
          id: formData.doorLockId.value,
          nameAliases:
            nameLanguageDoorLock?.length > 0
              ? nameLanguageDoorLock?.map((lang) => {
                  return {
                    languageId: lang.languageCode,
                    alias: lang.value,
                  };
                })
              : { languageId: '', alias: '' },
        },
        areas: formData.areas.value.map((a) => {
          return {
            name: a.name,
            id: a.id,
            lights: buildLightObject(formData.lights.value.filter((c) => c.roomArea === a.id)),
            thermostats: buildThermoObject(
              formData.thermostats.value.filter((c) => c.roomArea === a.id),
            ),
            curtains: buildCurtainObject(
              formData.curtains.value.filter((c) => c.roomArea === a.id),
            ),
            scenes: buildSceneObject(formData.scenes.value.filter((c) => c.roomArea === a.id)),
            nameAliases: a?.languageNames?.map((lang) => {
              return {
                languageId: lang.languageCode,
                alias: lang.value,
              };
            }),
          };
        }),
      };
      try {
        dispatch(stepUpLoaderCount());
        onDrawerToggle();
        if (template) {
          await updateExisitingTempalte(template?.id, payload);
          notificationManager('success', 'Template updated successfully');
        } else {
          await createNewTempalte(payload);
          notificationManager('success', 'Template created successfully');
        }
        dispatch(fetchGRETemplates(hotelId));
      } catch (err) {
        err?.graphQLErrors
          ? notificationManager('danger', err?.graphQLErrors?.[0]?.message)
          : template
          ? notificationManager('danger', 'Failed to update Template')
          : notificationManager('danger', 'Failed to create Template');
      } finally {
        dispatch(stepDownLoaderCount());
      }
      setLoading(false);
      clearLanguageInputs();
    }
  };

  const handleLangNameChange = (obj) => {
    if (nameLanguages) {
      setNameLanguages(
        nameLanguages.map((lang) => {
          if (lang.languageCode === obj.languageCode) {
            let val = { ...lang };
            val.value = obj.value;
            val.langageValue = obj.value;
            return val;
          } else {
            return lang;
          }
        }),
      );
    }
  };

  const handleLangNameChangeDoorLock = (obj) => {
    setNameLanguageDoorLock(
      nameLanguageDoorLock.map((lang) => {
        if (lang.languageCode === obj.languageCode) {
          let val = { ...lang };
          val.value = obj.value;
          val.langageValue = obj.value;
          return val;
        } else {
          return lang;
        }
      }),
    );
  };

  const onChnageUpdateAttribute = (type, newAttr) => {
    const vendorAttrCopy = { ...vendorAttribute };
    switch (type) {
      case LIGHT:
        vendorAttrCopy.lights.default = newAttr;
        break;
      case SCENE:
        vendorAttrCopy.scenes.default = newAttr;
        break;
      case THERMO:
        vendorAttrCopy.thermostats.default = newAttr;
        break;
      case CURTAIN:
        vendorAttrCopy.curtains.default = newAttr;
        break;
      case DOOR_LOCK:
        vendorAttrCopy.doorLock.default = newAttr;
        break;
      default:
        return vendorAttrCopy;
    }
    setVendorAttribute(vendorAttrCopy);
  };

  const onChnageThermoCustomAttr = (type, newAttr) => {
    if (type === THERMO) {
      const vendorAttrCopy = { ...vendorAttribute };
      vendorAttrCopy.thermostats.custom = newAttr;
      setVendorAttribute(vendorAttrCopy);
    }
  };

  const handleSelectedVendor = (vendors, selectedVendor) => {
    if (vendors) {
      return vendors.find((vendor) => vendor.id === selectedVendor);
    }
  };

  const handleLightsTypeChange = (e) => {
    const tempLightDimmerLevel = { ...lightFormData.dimmerLevel };
    tempLightDimmerLevel.validations = e.value === 'DIMMER' ? ['required'] : [];
    setLightFormData({ dimmerLevel: tempLightDimmerLevel });
    setLightFormData({ type: e });
  };

  const handleSceneLightTypeChange = (e) => {
    const tempSceneLightDimmerLevel = { ...sceneFormData.dimmerLevel };
    tempSceneLightDimmerLevel.validations = e.value === 'DIMMER' ? ['required'] : [];
    setSceneFormData({ dimmerLevel: tempSceneLightDimmerLevel });
    setSceneFormData({ type: e });
  };

  return (
    <form className='template-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-1 w-100 mt-4'>
          <div className='col-md-4'>
            <span className='page-title'>{template ? 'Edit Template' : 'Create Template'}</span>
          </div>
          <div className='col-md-7 d-flex'>
            <Tabs
              value={tabValue}
              indicatorColor='primary'
              onChange={handleTabChange}
              aria-label='hotel-add-tabs'
              textColor='primary'
              variant='scrollable'
              scrollButtons='auto'
              className='template-tabs'
            >
              <Tab label='Details' />
              <Tab label='Lights' />
              <Tab label='Scenes' />
              <Tab label='Thermostat' />
              <Tab label='Curtains' />
              <Tab label='Door Lock' />
            </Tabs>
          </div>
          <div className='col-md-1 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          {tabValue === 0 && (
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title'>Details</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.name}
                    handleInputChange={(e) => {
                      setFormData({ name: e });
                    }}
                    maxLength={30}
                    endAdornment={true}
                    characterCount={true}
                  />
                </div>
              </div>
              <div className='custom-upload col-md-12'>
                <h4 className='tab-title mt-4'>Door Camera</h4>
                <RadioGroup
                  row
                  aria-label={formData.doorCamera.fieldName}
                  onChange={(e) => {
                    const doorCamera = { ...formData.doorCamera };
                    doorCamera.value = e.target.value;
                    setFormData({ doorCamera });
                  }}
                  value={formData.doorCamera.value}
                  name={formData.doorCamera.fieldName}
                  className='document-type mb-3'
                >
                  <FormControlLabel
                    value='active'
                    control={<Radio color='primary' />}
                    label='Active'
                    className='me-5'
                  />
                  <FormControlLabel
                    value='inactive'
                    control={<Radio color='primary' />}
                    label='Inactive'
                    className='mx-5'
                  />
                </RadioGroup>
              </div>
              <h4 className='tab-title mt-4'>Room Area</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={areaFormData.id}
                    handleInputChange={(e) => {
                      setAreaFormData({ id: e });
                    }}
                    maxLength={15}
                    endAdornment={true}
                    characterCount={true}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={areaFormData.name}
                    handleInputChange={(e) => {
                      setAreaFormData({ name: e });
                    }}
                    maxLength={15}
                    endAdornment={true}
                    characterCount={true}
                  />
                </div>
                {nameLanguages &&
                  nameLanguages?.map((lang, key) => (
                    <div className='col-md-6 mb-3' key={key}>
                      <CustomTextField
                        alias={'Room'}
                        item={lang}
                        handleInputChange={(e) => {
                          handleLangNameChange(e);
                        }}
                        maxLength={15}
                        endAdornment={true}
                        characterCount={true}
                      />
                    </div>
                  ))}
              </div>

              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <Button
                    variant='outlined'
                    color='primary'
                    onClick={() => {
                      onItemAdd(areaFormData, 'areas', setAreaFormData);
                    }}
                  >
                    Add
                  </Button>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3 drag-item'>
                  <DragDropContext onDragEnd={(e) => onDragEnd(e, 'areas')}>
                    <Droppable droppableId='droppable'>
                      {(provided, snapshot) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          style={getListStyle(snapshot.isDraggingOver)}
                        >
                          {formData.areas.value.map((item, index) => (
                            <Draggable
                              key={'' + item.index}
                              draggableId={'' + item.index}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={getItemStyle(
                                    snapshot.isDragging,
                                    provided.draggableProps.style,
                                  )}
                                  className='list-item'
                                >
                                  <DragIndicator className='list-item-drag col-2' />
                                  <TextField
                                    label='Area name'
                                    id='area-name'
                                    value={item.name}
                                    InputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                  <TextField
                                    label='Area id'
                                    id='area-id'
                                    value={item.id}
                                    InputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                  <Edit
                                    onClick={(e) => onItemEdit(index, 'areas', 'AREA_FORM')}
                                    color={'secondary'}
                                  />
                                  <RemoveCircleRounded
                                    onClick={(e) => onItemDelete(index, 'areas')}
                                    className='mx-2 list-item-remove'
                                    color='secondary'
                                  ></RemoveCircleRounded>
                                </div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </div>
            </div>
          )}
          {tabValue === 1 && (
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title'>Light Configurations</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData.lightsVendor}
                    handleInputChange={(e) => {
                      onVendorSelect(e, 'lightsVendor');
                    }}
                    disabled={formData.lights.value.length > 0}
                    options={allVendors?.lights}
                  />
                </div>
              </div>
              {formData.lightsVendor.value !== '' && (
                <VendorCard
                  type={LIGHT}
                  vendorDetails={handleSelectedVendor(
                    allVendors?.lights,
                    formData.lightsVendor.value,
                  )}
                  onChangeUpdateAttr={(e) => {
                    onChnageUpdateAttribute(LIGHT, e);
                  }}
                  vendorAttr={vendorAttribute}
                />
              )}
              <h4 className='tab-title mt-4'>Add Lights</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={lightFormData.roomArea}
                    handleInputChange={(e) => {
                      setLightFormData({ roomArea: e });
                    }}
                    options={formData.areas.value}
                    hideNullOption
                    disabled={formData.lightsVendor.value === ''}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={lightFormData.id}
                    handleInputChange={(e) => {
                      setLightFormData({ id: e });
                    }}
                    disabled={formData.lightsVendor.value === ''}
                    maxLength={15}
                    endAdornment={true}
                    characterCount={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={lightFormData.name}
                    handleInputChange={(e) => {
                      setLightFormData({ name: e });
                    }}
                    disabled={formData.lightsVendor.value === ''}
                    maxLength={15}
                    endAdornment={true}
                    characterCount={true}
                  />
                </div>
                {nameLanguages &&
                  nameLanguages.map((lang, key) => (
                    <div className='col-md-6 mb-3' key={key}>
                      <CustomTextField
                        alias={'Light'}
                        item={lang}
                        handleInputChange={(e) => {
                          handleLangNameChange(e);
                        }}
                        disabled={formData.lightsVendor.value === ''}
                        maxLength={15}
                        endAdornment={true}
                        characterCount={true}
                      />
                    </div>
                  ))}
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={lightFormData.type}
                    handleInputChange={(e) => handleLightsTypeChange(e)}
                    options={lightType}
                    disabled={formData.lightsVendor.value === ''}
                    hideNullOption
                  />
                </div>
                {lightFormData.type.value === 'DIMMER' && (
                  <div className='col-md-6 mb-3'>
                    <CustomSelect
                      item={lightFormData.dimmerLevel}
                      handleInputChange={(e) => {
                        setLightFormData({ dimmerLevel: e });
                      }}
                      disabled={formData.lightsVendor.value === ''}
                      options={[2, 4, 6]}
                      hideNullOption
                    />
                  </div>
                )}
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={lightFormData.icon}
                    handleInputChange={(e) => {
                      setLightFormData({ icon: e });
                    }}
                    options={lightIcons}
                    disabled={formData.lightsVendor.value === ''}
                    hideNullOption
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <Button
                    variant='outlined'
                    color='primary'
                    onClick={() => {
                      onItemAdd(lightFormData, 'lights', setLightFormData);
                    }}
                    disabled={formData.lightsVendor.value === ''}
                  >
                    Add
                  </Button>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3 drag-item'>
                  <DragDropContext onDragEnd={(e) => onDragEnd(e, 'lights')}>
                    <Droppable droppableId='droppable'>
                      {(provided, snapshot) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          style={getListStyle(snapshot.isDraggingOver)}
                        >
                          {formData?.lights?.value?.map((item, index) => (
                            <Draggable
                              key={'' + item.index}
                              draggableId={'' + item.index}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={getItemStyle(
                                    snapshot.isDragging,
                                    provided.draggableProps.style,
                                  )}
                                  className='list-item'
                                >
                                  <DragIndicator className='list-item-drag col-2' />
                                  <div className='row w-100 mx-3'>
                                    <div className='col-md-6 mb-3'>
                                      <TextField
                                        label='Light name'
                                        id='light-name'
                                        className='w-100'
                                        value={item.name}
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                      <TextField
                                        label='Light Id'
                                        id='light-id'
                                        className='w-100'
                                        value={item.id}
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                      <TextField
                                        label='Room Area'
                                        className='w-100'
                                        id='light-roomarea'
                                        value={item.roomArea}
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                      <TextField
                                        label='Light Type'
                                        id='light-type'
                                        className='w-100'
                                        value={item.type}
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>

                                    {item.type === 'Dimmer' && (
                                      <div className='col-md-6 mb-3'>
                                        <TextField
                                          label='Dimmer Level'
                                          id='light-dimmerLevel'
                                          className='w-100'
                                          value={item.dimmerLevel}
                                          InputProps={{
                                            readOnly: true,
                                          }}
                                        />
                                      </div>
                                    )}
                                    <div className='col-md-6 mb-3'>
                                      <TextField
                                        label='Light Icon'
                                        id='light-icon'
                                        className='w-100'
                                        value={item.icon}
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <Edit
                                    onClick={(e) => onItemEdit(index, 'lights', 'LIGHT_FORM')}
                                    color={'secondary'}
                                  />
                                  <RemoveCircleRounded
                                    onClick={(e) => onItemDelete(index, 'lights')}
                                    className='mx-2 list-item-remove'
                                    color='secondary'
                                  ></RemoveCircleRounded>
                                </div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </div>
            </div>
          )}
          {tabValue === 2 && (
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title'>Scenes Configurations</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData.scenesVendor}
                    handleInputChange={(e) => {
                      onVendorSelect(e, 'scenesVendor');
                    }}
                    disabled={formData.scenes.value.length > 0}
                    options={allVendors?.scenes}
                  />
                </div>
              </div>
              {formData.scenesVendor.value !== '' && (
                <VendorCard
                  type={SCENE}
                  vendorDetails={handleSelectedVendor(
                    allVendors?.scenes,
                    formData.scenesVendor.value,
                  )}
                  onChangeUpdateAttr={(e) => {
                    onChnageUpdateAttribute(SCENE, e);
                  }}
                  vendorAttr={vendorAttribute}
                />
              )}
              <h4 className='tab-title mt-4'>Add Scene</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={sceneFormData.roomArea}
                    handleInputChange={(e) => {
                      setSceneFormData({ roomArea: e });
                    }}
                    options={formData.areas.value}
                    disabled={formData.scenesVendor.value === ''}
                    hideNullOption
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={sceneFormData.id}
                    handleInputChange={(e) => {
                      setSceneFormData({ id: e });
                    }}
                    disabled={formData.scenesVendor.value === ''}
                    maxLength={15}
                    endAdornment={true}
                    characterCount={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={sceneFormData.name}
                    handleInputChange={(e) => {
                      setSceneFormData({ name: e });
                    }}
                    disabled={formData.scenesVendor.value === ''}
                    maxLength={15}
                    endAdornment={true}
                    characterCount={true}
                  />
                </div>
                {nameLanguages &&
                  nameLanguages.map((lang, key) => (
                    <div className='col-md-6 mb-3' key={key}>
                      <CustomTextField
                        alias={'Scene'}
                        item={lang}
                        handleInputChange={(e) => {
                          handleLangNameChange(e);
                        }}
                        disabled={formData.scenesVendor.value === ''}
                        maxLength={15}
                        endAdornment={true}
                        characterCount={true}
                      />
                    </div>
                  ))}
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={sceneFormData.type}
                    handleInputChange={(e) => handleSceneLightTypeChange(e)}
                    options={lightType}
                    disabled={formData.scenesVendor.value === ''}
                    hideNullOption
                  />
                </div>
                {sceneFormData.type.value === 'DIMMER' && (
                  <div className='col-md-6 mb-3'>
                    <CustomSelect
                      item={sceneFormData.dimmerLevel}
                      handleInputChange={(e) => {
                        setSceneFormData({ dimmerLevel: e });
                      }}
                      disabled={formData.scenesVendor.value === ''}
                      options={[2, 4, 6]}
                      hideNullOption
                    />
                  </div>
                )}
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <Button
                    variant='outlined'
                    color='primary'
                    onClick={() => {
                      onItemAdd(sceneFormData, 'scenes', setSceneFormData);
                    }}
                    disabled={formData.scenesVendor.value === ''}
                  >
                    Add
                  </Button>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3 drag-item'>
                  <DragDropContext onDragEnd={(e) => onDragEnd(e, 'scenes')}>
                    <Droppable droppableId='droppable'>
                      {(provided, snapshot) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          style={getListStyle(snapshot.isDraggingOver)}
                        >
                          {formData?.scenes?.value?.map((item, index) => (
                            <Draggable
                              key={'' + item.index}
                              draggableId={'' + item.index}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={getItemStyle(
                                    snapshot.isDragging,
                                    provided.draggableProps.style,
                                  )}
                                  className='list-item'
                                >
                                  <DragIndicator className='list-item-drag col-2' />
                                  <div className='row w-100 mx-3'>
                                    <div className='col-md-6 mb-3'>
                                      <TextField
                                        label='Scene name'
                                        id='scene-name'
                                        className='w-100'
                                        value={item.name}
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                      <TextField
                                        label='Scene Id'
                                        id='scene-name'
                                        className='w-100'
                                        value={item.id}
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                      <TextField
                                        label='Room Area'
                                        className='w-100'
                                        id='scene-roomarea'
                                        value={item.roomArea}
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <Edit
                                    onClick={(e) => onItemEdit(index, 'scenes', 'SCENE_FORM')}
                                    color={'secondary'}
                                  />
                                  <RemoveCircleRounded
                                    onClick={(e) => onItemDelete(index, 'scenes')}
                                    className='mx-2 list-item-remove'
                                    color='secondary'
                                  ></RemoveCircleRounded>
                                </div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </div>
            </div>
          )}
          {tabValue === 3 && (
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title'>Thermostat Configurations</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData.thermostatVendor}
                    handleInputChange={(e) => {
                      onVendorSelect(e, 'thermostatVendor');
                    }}
                    options={allVendors.thermostats}
                    disabled={formData.thermostats.value.length > 0}
                  />
                </div>
              </div>
              {formData.thermostatVendor.value !== '' && (
                <VendorCard
                  type={THERMO}
                  vendorDetails={handleSelectedVendor(
                    allVendors?.thermostats,
                    formData.thermostatVendor.value,
                  )}
                  onChangeUpdateAttr={(e) => {
                    onChnageUpdateAttribute(THERMO, e);
                  }}
                  onChangeThermostatAttr={(e) => {
                    onChnageThermoCustomAttr(THERMO, e);
                  }}
                  vendorAttr={vendorAttribute}
                />
              )}
              <h4 className='tab-title mt-4'>Add Thermostat</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={thermostatFormData.roomArea}
                    handleInputChange={(e) => {
                      setThermostatFormData({ roomArea: e });
                    }}
                    options={formData.areas.value}
                    disabled={formData.thermostatVendor.value === ''}
                    hideNullOption
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={thermostatFormData.id}
                    handleInputChange={(e) => {
                      setThermostatFormData({ id: e });
                    }}
                    disabled={formData.thermostatVendor.value === ''}
                    maxLength={15}
                    endAdornment={true}
                    characterCount={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={thermostatFormData.name}
                    handleInputChange={(e) => {
                      setThermostatFormData({ name: e });
                    }}
                    disabled={formData.thermostatVendor.value === ''}
                    maxLength={15}
                    endAdornment={true}
                    characterCount={true}
                  />
                </div>
                {nameLanguages &&
                  nameLanguages.map((lang, key) => (
                    <div className='col-md-6 mb-3' key={key}>
                      <CustomTextField
                        alias={'Thermostat'}
                        item={lang}
                        handleInputChange={(e) => {
                          handleLangNameChange(e);
                        }}
                        disabled={formData.thermostatVendor.value === ''}
                        maxLength={15}
                        endAdornment={true}
                        characterCount={true}
                      />
                    </div>
                  ))}
              </div>

              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <Button
                    variant='outlined'
                    color='primary'
                    onClick={() => {
                      onItemAdd(thermostatFormData, 'thermostats', setThermostatFormData);
                    }}
                    disabled={formData.thermostatVendor.value === ''}
                  >
                    Add
                  </Button>
                </div>
              </div>
              <div className='row item-scroll-200'>
                <div className='col-md-12 mb-3 drag-item'>
                  <DragDropContext onDragEnd={(e) => onDragEnd(e, 'thermostats')}>
                    <Droppable droppableId='droppable'>
                      {(provided, snapshot) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          style={getListStyle(snapshot.isDraggingOver)}
                        >
                          {formData?.thermostats?.value?.map((item, index) => (
                            <Draggable
                              key={'' + item.index}
                              draggableId={'' + item.index}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={getItemStyle(
                                    snapshot.isDragging,
                                    provided.draggableProps.style,
                                  )}
                                  className='list-item'
                                >
                                  <DragIndicator className='list-item-drag col-2' />
                                  <div className='row w-100 mx-3'>
                                    <div className='col-md-6 mb-3'>
                                      <TextField
                                        label='Thermostat name'
                                        id='thermostat-name'
                                        className='w-100'
                                        value={item.name}
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                      <TextField
                                        label='Thermostat Id'
                                        id='thermostat-name'
                                        className='w-100'
                                        value={item.id}
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                      <TextField
                                        label='Room Area'
                                        className='w-100'
                                        id='thermostat-roomarea'
                                        value={item.roomArea}
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <Edit
                                    onClick={(e) => onItemEdit(index, 'thermostats', 'THERMO_FORM')}
                                  />
                                  <RemoveCircleRounded
                                    onClick={(e) => onItemDelete(index, 'thermostats')}
                                    className='mx-2 list-item-remove'
                                  />
                                </div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </div>
            </div>
          )}
          {tabValue === 4 && (
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title'>Curtains Configurations</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData.curtainsVendor}
                    handleInputChange={(e) => {
                      onVendorSelect(e, 'curtainsVendor');
                    }}
                    options={allVendors.curtains}
                    disabled={formData.curtains.value.length > 0}
                  />
                </div>
              </div>
              {formData.curtainsVendor.value !== '' && (
                <VendorCard
                  type={CURTAIN}
                  vendorDetails={handleSelectedVendor(
                    allVendors?.curtains,
                    formData.curtainsVendor.value,
                  )}
                  onChangeUpdateAttr={(e) => {
                    onChnageUpdateAttribute(CURTAIN, e);
                  }}
                  vendorAttr={vendorAttribute}
                />
              )}
              <h4 className='tab-title mt-4'>Add Curtain</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={curtainFormData.roomArea}
                    handleInputChange={(e) => {
                      setCurtaintFormData({ roomArea: e });
                    }}
                    options={formData.areas.value}
                    disabled={formData.curtainsVendor.value === ''}
                    hideNullOption
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={curtainFormData.id}
                    handleInputChange={(e) => {
                      setCurtaintFormData({ id: e });
                    }}
                    disabled={formData.curtainsVendor.value === ''}
                    maxLength={15}
                    endAdornment={true}
                    characterCount={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={curtainFormData.name}
                    handleInputChange={(e) => {
                      setCurtaintFormData({ name: e });
                    }}
                    disabled={formData.curtainsVendor.value === ''}
                    maxLength={15}
                    endAdornment={true}
                    characterCount={true}
                  />
                </div>
                {nameLanguages &&
                  nameLanguages.map((lang, key) => (
                    <div className='col-md-6 mb-3' key={key}>
                      <CustomTextField
                        alias={'Curtain'}
                        item={lang}
                        handleInputChange={(e) => {
                          handleLangNameChange(e);
                        }}
                        disabled={formData.curtainsVendor.value === ''}
                        maxLength={15}
                        endAdornment={true}
                        characterCount={true}
                      />
                    </div>
                  ))}
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={curtainFormData.type}
                    handleInputChange={(e) => {
                      setCurtaintFormData({ type: e });
                    }}
                    options={curtainType}
                    disabled={formData.curtainsVendor.value === ''}
                    hideNullOption
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <Button
                    variant='outlined'
                    color='primary'
                    onClick={() => {
                      onItemAdd(curtainFormData, 'curtains', setCurtaintFormData);
                    }}
                    disabled={formData.curtainsVendor.value === ''}
                  >
                    Add
                  </Button>
                </div>
              </div>
              <div className='row item-scroll-200'>
                <div className='col-md-12 mb-3 drag-item'>
                  <DragDropContext onDragEnd={(e) => onDragEnd(e, 'curtains')}>
                    <Droppable droppableId='droppable'>
                      {(provided, snapshot) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          style={getListStyle(snapshot.isDraggingOver)}
                        >
                          {formData?.curtains?.value?.map((item, index) => (
                            <Draggable
                              key={'' + item.index}
                              draggableId={'' + item.index}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={getItemStyle(
                                    snapshot.isDragging,
                                    provided.draggableProps.style,
                                  )}
                                  className='list-item'
                                >
                                  <DragIndicator className='list-item-drag col-2' />
                                  <div className='row w-100 mx-3'>
                                    <div className='col-md-6 mb-3'>
                                      <TextField
                                        label='Crtain name'
                                        id='curtain-name'
                                        className='w-100'
                                        value={item.name}
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                      <TextField
                                        label='Crtain Id'
                                        id='curtain-name'
                                        className='w-100'
                                        value={item.id}
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                      <TextField
                                        label='Room Area'
                                        className='w-100'
                                        id='curtain-roomarea'
                                        value={item.roomArea}
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                      <TextField
                                        label='Curtan Type'
                                        className='w-100'
                                        id='curtain-type'
                                        value={item.type}
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <Edit
                                    onClick={(e) => onItemEdit(index, 'curtains', 'CURTAIN_FORM')}
                                    color={'secondary'}
                                  />
                                  <RemoveCircleRounded
                                    onClick={(e) => onItemDelete(index, 'curtains')}
                                    className='mx-2 list-item-remove'
                                    color='secondary'
                                  />
                                </div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </div>
            </div>
          )}
          {tabValue === 5 && (
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title'>Door Lock Configurations</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData.doorLockVendor}
                    handleInputChange={(e) => {
                      onVendorSelect(e, 'doorLockVendor');
                    }}
                    options={allVendors?.doorLock}
                    disabled={
                      formData.doorLockName.value !== '' ||
                      formData.doorLockId.value !== '' ||
                      nameLanguageDoorLock
                        ?.map((doorLockLang) => doorLockLang?.value !== '')
                        .includes(true)
                    }
                  />
                </div>
              </div>
              {formData.doorLockVendor.value !== '' && (
                <VendorCard
                  type={DOOR_LOCK}
                  vendorDetails={handleSelectedVendor(
                    allVendors?.doorLock,
                    formData.doorLockVendor.value,
                  )}
                  onChangeUpdateAttr={(e) => {
                    onChnageUpdateAttribute(DOOR_LOCK, e);
                  }}
                  vendorAttr={vendorAttribute}
                />
              )}
              <h4 className='tab-title mt-4'>Add Door Lock</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.doorLockId}
                    handleInputChange={(e) => {
                      setFormData({ doorLockId: e });
                    }}
                    disabled={formData.doorLockVendor.value === ''}
                    maxLength={15}
                    endAdornment={true}
                    characterCount={true}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.doorLockName}
                    handleInputChange={(e) => {
                      setFormData({ doorLockName: e });
                    }}
                    disabled={formData.doorLockVendor.value === ''}
                    maxLength={15}
                    endAdornment={true}
                    characterCount={true}
                  />
                </div>
              </div>
              <div className='row'>
                {nameLanguageDoorLock?.map((lang, key) => (
                  <div className='col-md-6 mb-3' key={key}>
                    <CustomTextField
                      alias={'Door Lock'}
                      item={lang}
                      handleInputChange={(e) => {
                        handleLangNameChangeDoorLock(e);
                      }}
                      disabled={formData.doorLockVendor.value === ''}
                      maxLength={15}
                      endAdornment={true}
                      characterCount={true}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            {tabValue < 5 ? (
              <Button
                variant='contained'
                color='primary'
                onClick={onNextClick}
                size='large'
                className='me-3'
                disabled={
                  isTabInValid ||
                  (tabValue === 0 && formData.areas.value.length === 0) ||
                  (tabValue === 1 &&
                    formData.lightsVendor.value !== '' &&
                    formData.lights.value.length === 0) ||
                  (tabValue === 2 &&
                    formData.scenesVendor.value !== '' &&
                    formData.scenes.value.length === 0) ||
                  (tabValue === 3 &&
                    formData.thermostatVendor.value !== '' &&
                    formData.thermostats.value.length === 0) ||
                  (tabValue === 4 &&
                    formData.curtainsVendor.value !== '' &&
                    formData.curtains.value.length === 0)
                }
              >
                Next
              </Button>
            ) : (
              <Button
                // disabled={loading}
                variant='contained'
                onClick={handleSubmit}
                className='me-3'
                color='primary'
                size='large'
                disabled={
                  formData?.doorLockVendor?.value !== '' &&
                  (formData?.doorLockName?.value === '' ||
                    formData?.doorLockId?.value === '' ||
                    nameLanguageDoorLock
                      ?.map((doorLockLang) => doorLockLang?.value === '')
                      ?.includes(true))
                }
              >
                {template && template.id ? 'Update' : 'Save'}
              </Button>
            )}
            <Button
              disabled={loading}
              variant='outlined'
              size='large'
              color='secondary'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
          {loading && (
            <div className='pt-4 col-md-12'>
              <LinearProgressBar />
            </div>
          )}
        </div>
      </div>
    </form>
  );
};

export default GuestRoomExperienceTemplateCreate;
